import Script from 'next/script';
import React from 'react';

/**
 * Reddit Ads conversion pixel. `rdt('init', ...)` also fires the pixel's own page view, so the
 * explicit `PageVisit` call afterwards is what Reddit's install instructions ask for and what
 * their pixel helper checks for.
 *
 * Unlike Meta and TikTok, the Reddit pixel exposes no runtime consent toggle, and the loaded
 * script cannot be taken back out of the page. Revoking consent therefore only stops the
 * `rdt()` calls we make ourselves; the pixel is not re-armed until the next page load, which
 * then happens without it. Keep this component behind ConsentGatedTrackers for that reason.
 */
const RedditPixel: React.FC<{ trackingId: string }> = ({ trackingId }) => {
    if (!trackingId) {
        return null;
    }
    return (
        <Script
            id="reddit-pixel"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);
rdt('init', '${trackingId}');
rdt('track', 'PageVisit');`
            }}
        />
    );
};

export default RedditPixel;
